import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React, { useContext, useState } from "react"
import * as Style from "./CourseProgress.module.scss"
import { Context } from "../store/UserProvider"
import ChangePass from "../sign-in-form/change-pass/ChangePass"
const CourseProgress = ({ watched, all_videos }) => {
  let percentage = (watched / all_videos) * 100
  let converted_percent = Math.round(percentage * 10) / 10
  const ctx = useContext(Context)
  const [showPassChange, setShowPassChange] = useState(false)

  const showHidePassWindow = () => {
    setShowPassChange(!showPassChange)
  }

  return (
    <>
      <div className={Style.wrapper}>
        <div onClick={showHidePassWindow} className={Style.user}>
          <StaticImage
            src="../../images/profile_picture.png"
            alt="profile picture"
            className={Style.image}
          />
          <div className={Style.profile}>
            <div className={Style.name}>
              {!ctx.userGlobalState ? "loading" : ctx.userGlobalState.name}
            </div>
            <Link className={Style.profile_link} to="">
              Profile &gt;
            </Link>
          </div>
        </div>
        <div className={Style.progress}>
          <div className={Style.progress_info}>
            <div className={Style.label}>Progress</div>
            <div className={Style.percentage}>{converted_percent}%</div>
          </div>
          <div className={Style.progress_bar}>
            <div
              className={Style.real_progress}
              style={{ width: `${converted_percent}%` }}
            ></div>
          </div>
        </div>
        <div></div>
        {showPassChange && (
          <ChangePass showHidePassWindow={showHidePassWindow} />
        )}
      </div>
      <div onClick={showHidePassWindow} className={Style.userComp}>
        <StaticImage
          src="../../images/profile_picture.png"
          alt="profile picture"
          className={Style.image}
        />
        <div className={Style.profile}>
          <div className={Style.name}>
            {!ctx.userGlobalState ? "loading" : ctx.userGlobalState.name}
          </div>
          <Link className={Style.profile_link} to="">
            Profile &gt;
          </Link>
        </div>
        {showPassChange && (
          <ChangePass showHidePassWindow={showHidePassWindow} />
        )}
      </div>
      <div className={Style.progressComp}>
        <div className={Style.progress_info}>
          <div className={Style.label}>Progress</div>
          <div className={Style.percentage}>{converted_percent}%</div>
        </div>
        <div className={Style.progress_bar}>
          <div
            className={Style.real_progress}
            style={{ width: `${converted_percent}%` }}
          ></div>
        </div>
      </div>
    </>
  )
}
export default CourseProgress
